export default "__VITE_ASSET__BuvZ$$YA__"